import React, { useEffect, useState } from 'react'
import { toast } from "react-toastify"
import axios from "axios"
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import MessageBox from '../../../components/CommonComponents/MessageBox'
import { showOrderDefaultURL } from '../../../components/CommonApis/CommonShowOrderApi'
import Response_Processing from '../../../layout/Others/Response_Processing'
import { FaEllipsisVertical } from 'react-icons/fa6';
import NoRecordTable from '../../../components/CommonComponents/NoRecordTable';
import { Link } from 'react-router-dom';
import AdminCustomButton from '../../../components/CommonComponents/AdminCustomButton';
import { getItemToken } from '../../../Utils/localStorageUtils';
import AdminSelectOptionModal from '../../../components/CommonComponents/AdminSelectOptionModal';
import AdminSwitch from '../../../components/CommonComponents/AdminSwitch';
import { IconEditFigma } from '../../../Assets/MyIcons';
import MessageLabel from '../../../components/CommonComponents/MessageLabel';

const ShowSettings = () => {
    const [apiData, setApiData] = useState([]);
    const [enableSetting, setEnableSetting] = useState([])
    const [enableSettingMobile, setEnableSettingMobile] = useState([])
    const [enableSettingTV, setEnableSettingTV] = useState([])
    const [enableSettingSamsung, setEnableSettingSamsung] = useState([])
    const [enableSettingLg, setEnableSettingLg] = useState([])
    const [series, setSeries] = useState([])
    const [seriesMobile, setSeriesMobile] = useState([])
    const [seriesId, setSeriesId] = useState(null)
    const [seriesMobileId, setSeriesMobileId] = useState(null)
    const [seriesTvId, setSeriesTvId] = useState(null)
    const [seriesTv, setSeriesTv] = useState([])
    const [seriesSamsung, setSeriesSamsung] = useState([])
    const [seriesSamsungId, setSeriesSamsungId] = useState(null)
    const [seriesLg, setSeriesLg] = useState([])
    const [seriesLgId, setSeriesLgId] = useState(null)
    const [showOverlay, setShowOverlay] = useState(false);
    const [modelClose, setModelClose] = useState(false);
    const [loading, setLoading] = useState(true)
    const [pendingCount, setPendingCount] = useState(0)
    const [withOutRefresh, setWithOutRefresh] = useState(false)

    const HeaderToken = getItemToken('access_token')

    const closeModal = () => {
        setModelClose(!modelClose);
        setEnableSetting((prev) =>
            prev?.map((status) =>
                status.name === "single_series"
                    ? { ...status, Web_HomePage_status: 0 }  // Update the value to 0
                    : status
            )
        );
    };


    const fetData = async () => {
        try {
            setPendingCount(c => c + 1)
            const response = await axios.get(`${showOrderDefaultURL?.listApi}`, { headers: HeaderToken })
            const result = response?.data?.Web_TvShows_HomePage_Order;
            if (response?.data?.status) setApiData(result)
        }
        catch (error) { console.error(error?.response?.data?.message) }
        finally { setPendingCount(c => c - 1) }
    }

    const enableData = async () => {
        try {
            setPendingCount(c => c + 1)
            const response = await axios.get(`${showOrderDefaultURL?.enableSettingURL}`, { headers: HeaderToken })
            const result = response?.data
            if (result?.status) {
                setEnableSetting(result?.Web_TvShows_HomePage_Order)
                setSeriesId(result?.Web_TvShowsHomePage?.single_series_id)
                setSeries(result?.list_of_series)
            }
        }
        catch (error) { console.error(error?.response?.data?.message) }
        finally { setPendingCount(c => c - 1) }
    }

    const enableMobileData = async () => {
        try {
            setPendingCount(c => c + 1)
            const response = await axios.get(`${showOrderDefaultURL?.enableSettingMobileURL}`, { headers: HeaderToken })
            const result = response?.data
            if (result?.status) {
                setEnableSettingMobile(result?.Mobile_TvShows_HomePage_Order)
                setSeriesMobileId(result?.MobileTvShows__HomePage?.single_series_id)
                setSeriesMobile(result?.list_of_series)
            }
        }
        catch (error) { console.error(error?.response?.data?.message) }
        finally { setPendingCount(c => c - 1) }
    }
    const enableTVData = async () => {
        try {
            setPendingCount(c => c + 1)
            const response = await axios.get(`${showOrderDefaultURL?.enableSettingTvURL}`, { headers: HeaderToken })
            const result = response?.data
            if (result?.status) {
                setEnableSettingTV(result?.TV_TvShows_HomePage_Order)
                setSeriesTvId(result?.TV_TvShows_HomePage?.single_series_id)
                setSeriesTv(result?.list_of_series)
            }
        }
        catch (error) { console.error(error?.response?.data?.message) }
        finally { setPendingCount(c => c - 1) }
    }

    const enableSamsungData = async () => {
        try {
            setPendingCount(c => c + 1)
            const response = await axios.get(`${showOrderDefaultURL?.enableSettingSamsungURL}`, { headers: HeaderToken })
            const result = response?.data
            if (result?.status) {
                setEnableSettingSamsung(result?.Samsung_TvShows_HomePage_Order)
                setSeriesSamsungId(result?.Samsung_TvShows_HomePage?.single_series_id)
                setSeriesSamsung(result?.list_of_series)
            }
        }
        catch (error) { console.error(error?.response?.data?.message) }
        finally { setPendingCount(c => c - 1) }
    }

    const enableLgData = async () => {
        try {
            setPendingCount(c => c + 1)
            const response = await axios.get(`${showOrderDefaultURL?.enableSettingLgURL}`, { headers: HeaderToken })
            const result = response?.data
            if (result?.status) {
                setEnableSettingLg(result?.LG_TvShows_HomePage_Order)
                setSeriesLgId(result?.LG_TvShows_HomePage?.single_series_id)
                setSeriesLg(result?.list_of_series)
            }
        }
        catch (error) { console.error(error?.response?.data?.message) }
        finally { setPendingCount(c => c - 1) }
    }

    const handleDragEnd = (result) => {
        if (!result.destination) return;
        const reorderedItems = Array?.from(apiData);
        const [movedItem] = reorderedItems?.splice(result?.source?.index, 1);
        reorderedItems.splice(result?.destination?.index, 0, movedItem);
        setApiData(reorderedItems);
        saveShuffleOrder(reorderedItems);
    };

    const saveShuffleOrder = async (updatedItems) => {
        setShowOverlay(true);
        if (!updatedItems || updatedItems?.length == 0) {
            console.error("Menu items are empty");
            return;
        }
        const positions = updatedItems?.map((menuItem) => menuItem?.id);
        const ids = updatedItems?.map((_, index) => index + 1);

        const requestData = {
            id: positions,
            position: ids,
        };

        try {
            const response = await axios.post(`${showOrderDefaultURL?.orderApi}`, requestData, { headers: HeaderToken });
            const result = response?.data;
            if (result?.status) {
                toast.success(result?.message);
                setShowOverlay(false);
                setWithOutRefresh(!withOutRefresh)
            }
            else {
                toast.error(result?.message);
                setShowOverlay(false);
            }
        } catch (err) {
            var errorMessage = err?.response?.data?.message;
            toast.error(errorMessage);
            setShowOverlay(false);
        }
    };

    const handleToggleSettings = async (name, value) => {
        const updatedSetting = enableSetting.map((item) => item?.name === name ? { ...item, Web_HomePage_status: value ? 0 : 1 } : item);
        setEnableSetting(updatedSetting)
        if (name == "single_series" && value == 0) {
            setModelClose(!modelClose)
        }
    }
    const handleToggleSettingsMobile = async (name, value) => {
        const updatedMobileSetting = enableSettingMobile?.map((item) => item?.name === name ? { ...item, Mobile_Homesetting_status: value ? 0 : 1 } : item);
        setEnableSettingMobile(updatedMobileSetting)
        if (name == "single_series" && value == 0) {
            setModelClose(!modelClose)
        }
    }
    const handleToggleSettingsTv = async (name, value) => {
        const updatedTvSetting = enableSettingTV?.map((item) => item?.name === name ? { ...item, TV_HomePage_status: value ? 0 : 1 } : item);
        setEnableSettingTV(updatedTvSetting)
        if (name == "single_series" && value == 0) { setModelClose(!modelClose) }
    }
    const handleToggleSettingsSamsung = async (name, value) => {
        const updatedSamsungSetting = enableSettingSamsung?.map((item) => item?.name === name ? { ...item, Samsung_HomePage_status: value ? 0 : 1 } : item);
        setEnableSettingSamsung(updatedSamsungSetting)
        if (name == "single_series" && value == 0) { setModelClose(!modelClose) }
    }
    const handleToggleSettingsLg = async (name, value) => {
        const updatedLgSetting = enableSettingLg?.map((item) => item?.name === name ? { ...item, LG_HomePage_status: value ? 0 : 1 } : item);
        setEnableSettingLg(updatedLgSetting)
        if (name == "single_series" && value == 0) { setModelClose(!modelClose) }
    }

    const updateSetting = async () => {
        setShowOverlay(true)
        try {
            const formData = new URLSearchParams();
            enableSetting?.forEach((item) => {
                const status = Number.isNaN(parseInt(item?.Web_HomePage_status, 10)) ? 0 : parseInt(item?.Web_HomePage_status, 10);
                formData.append(item?.name, status);
            });
            const response = await axios.post(`${showOrderDefaultURL?.updateSettingURL}`, formData, {
                headers: {
                    ...HeaderToken,
                    'Content-Type': 'application/x-www-form-urlencoded' // Specify the content type
                }
            });
            const result = response.data;
            if (result?.status) {
                toast.success(result?.message);
                setShowOverlay(false);
                setWithOutRefresh(!withOutRefresh)
            }
            else {
                toast.error(result?.message);
                setShowOverlay(false);
            }
        } catch (err) {
            var errorMessage = err?.response?.data?.message;
            toast.error(errorMessage);
            setShowOverlay(false);
        }
    }

    const updateSettingMobile = async () => {
        setShowOverlay(true)
        try {
            const formData = new URLSearchParams();
            enableSettingMobile?.forEach((item) => {
                const status = Number.isNaN(parseInt(item?.Mobile_Homesetting_status, 10)) ? 0 : parseInt(item?.Mobile_Homesetting_status, 10);
                formData.append(item?.name, status);
            });
            const response = await axios.post(`${showOrderDefaultURL?.updateSettingMobileURL}`, formData, {
                headers: {
                    ...HeaderToken,
                    // 'Content-Type': 'application/x-www-form-urlencoded' // Specify the content type
                }
            });
            const result = response.data;
            if (result?.status) {
                toast.success(result?.message);
                setShowOverlay(false);
                setWithOutRefresh(!withOutRefresh)
            }
            else {
                toast.error(result?.message);
                setShowOverlay(false);
            }
        } catch (err) {
            var errorMessage = err?.response?.data?.message;
            toast.error(errorMessage);
            setShowOverlay(false);
        }
    }
    const updateSettingTv = async () => {
        setShowOverlay(true)
        try {
            const formData = new URLSearchParams();
            enableSettingTV?.forEach((item) => {
                const status = Number.isNaN(parseInt(item?.TV_HomePage_status, 10)) ? 0 : parseInt(item?.TV_HomePage_status, 10);
                formData.append(item?.name, status);
            });
            const response = await axios.post(`${showOrderDefaultURL?.updateSettingTvURL}`, formData, {
                headers: { ...HeaderToken, 'Content-Type': 'application/x-www-form-urlencoded' }
            });
            const result = response.data;
            if (result?.status) { toast.success(result?.message); setShowOverlay(false); setWithOutRefresh(!withOutRefresh) }
            else { toast.error(result?.message); setShowOverlay(false); }
        } catch (err) { toast.error(err?.response?.data?.message); setShowOverlay(false); }
    }

    const updateSettingSamsung = async () => {
        setShowOverlay(true)
        try {
            const formData = new URLSearchParams();
            enableSettingSamsung?.forEach((item) => {
                const status = Number.isNaN(parseInt(item?.Samsung_HomePage_status, 10)) ? 0 : parseInt(item?.Samsung_HomePage_status, 10);
                formData.append(item?.name, status);
            });
            const response = await axios.post(`${showOrderDefaultURL?.updateSettingSamsungURL}`, formData, {
                headers: { ...HeaderToken, 'Content-Type': 'application/x-www-form-urlencoded' }
            });
            const result = response.data;
            if (result?.status) { toast.success(result?.message); setShowOverlay(false); setWithOutRefresh(!withOutRefresh) }
            else { toast.error(result?.message); setShowOverlay(false); }
        } catch (err) { toast.error(err?.response?.data?.message); setShowOverlay(false); }
    }

    const updateSettingLg = async () => {
        setShowOverlay(true)
        try {
            const formData = new URLSearchParams();
            enableSettingLg?.forEach((item) => {
                const status = Number.isNaN(parseInt(item?.LG_HomePage_status, 10)) ? 0 : parseInt(item?.LG_HomePage_status, 10);
                formData.append(item?.name, status);
            });
            const response = await axios.post(`${showOrderDefaultURL?.updateSettingLgURL}`, formData, {
                headers: { ...HeaderToken, 'Content-Type': 'application/x-www-form-urlencoded' }
            });
            const result = response.data;
            if (result?.status) { toast.success(result?.message); setShowOverlay(false); setWithOutRefresh(!withOutRefresh) }
            else { toast.error(result?.message); setShowOverlay(false); }
        } catch (err) { toast.error(err?.response?.data?.message); setShowOverlay(false); }
    }

    const singleSeriesUpdate = async (id) => {
        if (id == null || id == "" || id == undefined) {
            toast.error("Please choose once single series")
        }
        else {
            setShowOverlay(true)
            try {
                const formData = { single_series_id: id };
                const response = await axios.post(`${showOrderDefaultURL?.singleSeriesURL}`, formData, { headers: HeaderToken });
                const result = response.data;
                if (result?.status) {
                    toast.success(result?.message);
                    setShowOverlay(false);
                    closeModal()
                    updateSetting()
                }
                else {
                    toast.error(result?.message);
                    setShowOverlay(false);
                }
            } catch (err) {
                var errorMessage = err?.response?.data?.message;
                toast.error(errorMessage);
                setShowOverlay(false);
            }
        }
    }

    const singleSeriesMobileUpdate = async (id) => {
        if (id == null || id == "" || id == undefined) {
            toast.error("Please choose once single series")
        }
        else {
            setShowOverlay(true)
            try {
                const formData = { single_series_id: id };
                const response = await axios.post(`${showOrderDefaultURL?.singleSeriesMobileURL}`, formData, { headers: HeaderToken });
                const result = response.data;
                if (result?.status) {
                    toast.success(result?.message);
                    setShowOverlay(false);
                    closeModal()
                    updateSettingMobile()
                }
                else {
                    toast.error(result?.message);
                    setShowOverlay(false);
                }
            } catch (err) {
                var errorMessage = err?.response?.data?.message;
                toast.error(errorMessage);
                setShowOverlay(false);
            }
        }
    }
    const singleSeriesTvUpdate = async (id) => {
        if (id == null || id == "" || id == undefined) { toast.error("Please choose once single series") }
        else {
            setShowOverlay(true)
            try {
                const formData = { single_series_id: id };
                const response = await axios.post(`${showOrderDefaultURL?.singleSeriesTvURL}`, formData, { headers: HeaderToken });
                const result = response.data;
                if (result?.status) { toast.success(result?.message); setShowOverlay(false); closeModal(); updateSettingTv() }
                else { toast.error(result?.message); setShowOverlay(false); }
            } catch (err) { toast.error(err?.response?.data?.message); setShowOverlay(false); }
        }
    }

    const singleSeriesSamsungUpdate = async (id) => {
        if (id == null || id == "" || id == undefined) { toast.error("Please choose once single series") }
        else {
            setShowOverlay(true)
            try {
                const formData = { single_series_id: id };
                const response = await axios.post(`${showOrderDefaultURL?.singleSeriesSamsungURL}`, formData, { headers: HeaderToken });
                const result = response.data;
                if (result?.status) { toast.success(result?.message); setShowOverlay(false); closeModal(); updateSettingSamsung() }
                else { toast.error(result?.message); setShowOverlay(false); }
            } catch (err) { toast.error(err?.response?.data?.message); setShowOverlay(false); }
        }
    }

    const singleSeriesLgUpdate = async (id) => {
        if (id == null || id == "" || id == undefined) { toast.error("Please choose once single series") }
        else {
            setShowOverlay(true)
            try {
                const formData = { single_series_id: id };
                const response = await axios.post(`${showOrderDefaultURL?.singleSeriesLgURL}`, formData, { headers: HeaderToken });
                const result = response.data;
                if (result?.status) { toast.success(result?.message); setShowOverlay(false); closeModal(); updateSettingLg() }
                else { toast.error(result?.message); setShowOverlay(false); }
            } catch (err) { toast.error(err?.response?.data?.message); setShowOverlay(false); }
        }
    }
    useEffect(() => {
        const loadAllData = async () => {
            setLoading(true);
            try {
                await Promise.all([
                    fetData(),
                    enableData(),
                    enableMobileData(),
                    enableTVData(),
                    enableSamsungData(),
                    enableLgData()
                ]);
            } catch (error) {
                console.error("Error loading show settings:", error);
            } finally {
                setLoading(false);
            }
        };
        loadAllData();
    }, [withOutRefresh])
    // console.log(enableSetting, 'enableSetting---------------------');

    return (
        <>
            <div>
                {showOverlay && <Response_Processing />}
                {modelClose && <AdminSelectOptionModal modelClose={modelClose} closeModal={closeModal} action={singleSeriesUpdate} modalHead="Choose Single Series" option={series} selectId={seriesId} />}
                {modelClose && <AdminSelectOptionModal modelClose={modelClose} closeModal={closeModal} action={singleSeriesMobileUpdate} modalHead="Choose Single Series" option={series} selectId={seriesMobileId} />}
                {modelClose && <AdminSelectOptionModal modelClose={modelClose} closeModal={closeModal} action={singleSeriesTvUpdate} modalHead="Choose Single Series" option={series} selectId={seriesTvId} />}
                {modelClose && <AdminSelectOptionModal modelClose={modelClose} closeModal={closeModal} action={singleSeriesSamsungUpdate} modalHead="Choose Single Series (Samsung)" option={seriesSamsung} selectId={seriesSamsungId} />}
                {modelClose && <AdminSelectOptionModal modelClose={modelClose} closeModal={closeModal} action={singleSeriesLgUpdate} modalHead="Choose Single Series (LG)" option={seriesLg} selectId={seriesLgId} />}
            </div>
            <div className='m-0 p-0'>
                <div className=''>
                    <section className='section container-fluid pt-3'>
                        <div className='p-0'>
                            <div id='webhomesettings'>
                                <div className='iq-card home_mobile'>
                                    <nav>
                                        <div className='nav nav-tabs' id='nav-tab' role='tablist'>
                                            <button className='nav-link active' id='nav-home-tab' data-bs-toggle='tab' data-bs-target='#nav-home' type='button' role='tab' aria-controls='nav-home' aria-selected='true'><h6>Shows - Web</h6></button>
                                            <button className='nav-link' id='nav-profile-tab' data-bs-toggle='tab' data-bs-target='#nav-profile' type='button' role='tab' aria-controls='nav-profile' aria-selected='false'><h6>Shows - Mobile</h6></button>
                                            <button className='nav-link' id='pills-contact-tab' data-bs-toggle='tab' data-bs-target='#pills-contact' type='button' role='tab' aria-controls='pills-contact' aria-selected='false'><h6>Shows - TV</h6></button>
                                            <button className='nav-link' id='nav-samsung-tab' data-bs-toggle='tab' data-bs-target='#nav-samsung' type='button' role='tab' aria-controls='nav-samsung' aria-selected='false'><h6>Shows - Samsung</h6></button>
                                            <button className='nav-link' id='nav-lg-tab' data-bs-toggle='tab' data-bs-target='#nav-lg' type='button' role='tab' aria-controls='nav-lg' aria-selected='false'><h6>Shows - LG</h6></button>
                                        </div>
                                    </nav>

                                    <div className='tab-content' id='nav-tabContent'>
                                        <div className='tab-pane fade show active' id='nav-home' role='tabpanel' aria-labelledby='nav-home-tab'>
                                            <div className='panel-body mt-3'>
                                                <h6>Web Shows HomePage Menu Settings</h6> <hr />

                                                <div className="row align-items-center theme-bg-color rounded-2 p-3">
                                                    {loading ? <NoRecordTable loader={true} /> :
                                                        <>
                                                            {enableSetting?.map((item) => {
                                                                return <div className={`col-12 col-md-6 category-order-title p-1 mb-2`}>
                                                                    <div className="input-group color-picker d-flex align-items-center justify-content-between">
                                                                        <MessageLabel text={item?.header_name} classname="theme-text-color" noMargin />
                                                                        <AdminSwitch name={item?.name} checked={item?.Web_HomePage_status} onChange={() => handleToggleSettings(item?.name, item?.Web_HomePage_status)} />
                                                                    </div>
                                                                </div>
                                                            })}
                                                            <div className='col-12 text-end mt-3'>
                                                                <AdminCustomButton saveMethod={updateSetting} saveText="Save Setting" />
                                                            </div>
                                                        </>}
                                                </div>
                                            </div>
                                        </div>

                                        <div className='tab-pane fade' id='nav-profile' role='tabpanel' aria-labelledby='nav-profile-tab'>
                                            <div className='panel-body mt-3'>
                                                <h6>Mobile Shows HomePage Menu Settings</h6> <hr />
                                                <div className="row align-items-center theme-bg-color rounded-2 p-3">
                                                    {loading ? <NoRecordTable loader={true} /> :
                                                        <>
                                                            {enableSettingMobile?.map((item) => {
                                                                return <div className={`col-12 col-md-6 category-order-title p-1 mb-2`}>
                                                                    <div className="input-group color-picker d-flex align-items-center justify-content-between">
                                                                        <MessageLabel text={item?.header_name} classname="theme-text-color" noMargin />
                                                                        <AdminSwitch name={item?.name} checked={item?.Mobile_Homesetting_status} onChange={() => handleToggleSettingsMobile(item?.name, item?.Mobile_Homesetting_status)} />
                                                                    </div>
                                                                </div>
                                                            })}
                                                            <div className='col-12 text-end mt-3'>
                                                                <AdminCustomButton saveMethod={updateSettingMobile} saveText="Save Setting" />
                                                            </div>
                                                        </>}
                                                </div>

                                            </div>
                                        </div>

                                        <div className='tab-pane fade' id='pills-contact' role='tabpanel' aria-labelledby='pills-contact-tab'>
                                            <div className='panel-body mt-3'>
                                                <h6>TV Shows HomePage Menu Settings</h6> <hr />
                                                <div className="row align-items-center theme-bg-color rounded-2 p-3">
                                                    {loading ? <NoRecordTable loader={true} /> :
                                                        <>
                                                            {enableSettingTV?.map((item) => {
                                                                return <div className={`col-12 col-md-6 category-order-title p-1 mb-2`}>
                                                                    <div className="input-group color-picker d-flex align-items-center justify-content-between">
                                                                        <MessageLabel text={item?.header_name} classname="theme-text-color" noMargin />
                                                                        <AdminSwitch name={item?.name} checked={item?.TV_HomePage_status} onChange={() => handleToggleSettingsTv(item?.name, item?.TV_HomePage_status)} />
                                                                    </div>
                                                                </div>
                                                            })}
                                                            <div className='col-12 text-end mt-3'>
                                                                <AdminCustomButton saveMethod={updateSettingTv} saveText="Save TV Setting" />
                                                            </div>
                                                        </>}
                                                </div>
                                            </div>
                                        </div>

                                        <div className='tab-pane fade' id='nav-samsung' role='tabpanel' aria-labelledby='nav-samsung-tab'>
                                            <div className='panel-body mt-3'>
                                                <h6>Samsung Shows HomePage Menu Settings</h6> <hr />
                                                <div className="row align-items-center theme-bg-color rounded-2 p-3">
                                                    {loading ? <NoRecordTable loader={true} /> :
                                                        <>
                                                            {enableSettingSamsung?.map((item) => {
                                                                return <div className={`col-12 col-md-6 category-order-title p-1 mb-2`}>
                                                                    <div className="input-group color-picker d-flex align-items-center justify-content-between">
                                                                        <MessageLabel text={item?.header_name} classname="theme-text-color" noMargin />
                                                                        <AdminSwitch name={item?.name} checked={item?.Samsung_HomePage_status} onChange={() => handleToggleSettingsSamsung(item?.name, item?.Samsung_HomePage_status)} />
                                                                    </div>
                                                                </div>
                                                            })}
                                                            <div className='col-12 text-end mt-3'>
                                                                <AdminCustomButton saveMethod={updateSettingSamsung} saveText="Save Samsung Setting" />
                                                            </div>
                                                        </>}
                                                </div>
                                            </div>
                                        </div>

                                        <div className='tab-pane fade' id='nav-lg' role='tabpanel' aria-labelledby='nav-lg-tab'>
                                            <div className='panel-body mt-3'>
                                                <h6>LG Shows HomePage Menu Settings</h6> <hr />
                                                <div className="row align-items-center theme-bg-color rounded-2 p-3">
                                                    {loading ? <NoRecordTable loader={true} /> :
                                                        <>
                                                            {enableSettingLg?.map((item) => {
                                                                return <div className={`col-12 col-md-6 category-order-title p-1 mb-2`}>
                                                                    <div className="input-group color-picker d-flex align-items-center justify-content-between">
                                                                        <MessageLabel text={item?.header_name} classname="theme-text-color" noMargin />
                                                                        <AdminSwitch name={item?.name} checked={item?.LG_HomePage_status} onChange={() => handleToggleSettingsLg(item?.name, item?.LG_HomePage_status)} />
                                                                    </div>
                                                                </div>
                                                            })}
                                                            <div className='col-12 text-end mt-3'>
                                                                <AdminCustomButton saveMethod={updateSettingLg} saveText="Save LG Setting" />
                                                            </div>
                                                        </>}
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                {/* Order List */}
                                <h4 className="admin-title mb-4 theme-text-color text-md-start">
                                    <MessageBox text="Order TvShow" classname="theme-text-color" />
                                </h4>
                                <div className="bootstrapTable theme-bg-color p-3 rounded-2">
                                    <div className="row m-0 theme-border-bottom-secondary pb-3">
                                        <div className="col-2 "> <label className="theme-text-color fw-bold fs-6"># </label> </div>
                                        <div className="col-5 "><label className="theme-text-color fw-bold fs-6">Name</label></div>
                                        <div className="col-5 "><label className="theme-text-color fw-bold fs-6"> Actions </label> </div>
                                    </div>
                                    <DragDropContext onDragEnd={handleDragEnd}>
                                        <Droppable droppableId="menu-items" className="theme-bg-color"   >
                                            {(provided) => (
                                                <ul  {...provided.droppableProps} ref={provided.innerRef} className="pb-5 px-0 theme-bg-color list-unstyled m-0 p-0">
                                                    {loading ? <NoRecordTable result={apiData?.length} loader={true} /> :
                                                        apiData?.map((item, index) => (
                                                            <Draggable key={item?.id.toString()} draggableId={item?.id.toString()} index={index} >
                                                                {(provided) => (
                                                                    <li ref={provided.innerRef} {...provided.draggableProps}  {...provided.dragHandleProps} className={` theme-bg-color theme-text-color  orderborder ${item.order} index ${index + 1} w-100 theme-border-bottom-secondary`} >
                                                                        <div className="row m-0 p-0 align-items-center">
                                                                            <div className="col-2  category-order-title">
                                                                                <div className='d-flex position-relative '>
                                                                                    <p className="theme-text-color mb-3 admin-input-title d-block position-relative"> {item?.order_id} </p>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-5  category-order-title">
                                                                                <MessageLabel text={item?.header_name} classname="theme-text-color" noMargin />
                                                                            </div>
                                                                            <div className="col-5  category-order-title">
                                                                                <div className="editdropdown">
                                                                                    <span className="editdropdown-button">
                                                                                        <span>
                                                                                            <FaEllipsisVertical className="theme-text-color" />
                                                                                        </span>
                                                                                    </span>
                                                                                    <div className="editdropdown-menu theme-bg-color">
                                                                                        <Link to={`/edit-show-order/${item?.id}`} className="theme-text-color  theme-bg-color">
                                                                                            <span>
                                                                                                <IconEditFigma styled={{ width: "20px", height: "20px" }} />
                                                                                                <MessageBox text="Edit" classname='ms-2 theme-text-color'></MessageBox>
                                                                                            </span>
                                                                                        </Link>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                )}
                                                            </Draggable>
                                                        ))}
                                                </ul>
                                            )}
                                        </Droppable>
                                    </DragDropContext>
                                </div>
                            </div>
                        </div>

                    </section>
                </div>
            </div>
        </>
    );
}

export default ShowSettings